import { render, staticRenderFns } from "./ContentUpload.vue?vue&type=template&id=0c640dfc&scoped=true"
import script from "./ContentUpload.vue?vue&type=script&lang=js"
export * from "./ContentUpload.vue?vue&type=script&lang=js"
import style0 from "./ContentUpload.vue?vue&type=style&index=0&id=0c640dfc&prod&lang=scss"
import style1 from "./ContentUpload.vue?vue&type=style&index=1&id=0c640dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c640dfc",
  null
  
)

export default component.exports